import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllEmailTemplates(_obj, params) {
    const res = await axios.get('api/email-templates/', { params });
    return res.data;
  },
  async getEmailTemplate(_obj, id) {
    const res = await axios.get(`api/email-templates/${id}/`);
    return res.data;
  },
  async createEmailTemplate(_obj, data) {
    return axios.post('api/email-templates/', data);
  },
  async updateEmailTemplate(_obj, { id, data }) {
    return axios.patch(`api/email-templates/${id}/`, data);
  },
  async deleteEmailTemplate(_obj, id) {
    return axios.delete(`api/email-templates/${id}/`);
  },
  async getAssetUploadUrl(_obj, data) {
    return axios.post('api/email-templates/upload-url/', data);
  },
  async previewTemplate(_obj, { id, body_html }) {
    return axios.post(`api/email-templates/${id}/preview/`, { body_html });
  },
};

export const emailTemplate = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
